export default {
	SET_SEARCH_TERM(state, payload) {
		state.listing.searchTerm = payload
	},

	SET_PAGE(state, payload) {
		state.listing.page = payload
	}
}
